// should have underscore prefix to load before other scripts
;(function () {
  // Module scripts run while readyState is already "interactive" but before DOMContentLoaded.
  // WebKit leaves the Navigation Timing L2 entry's domContentLoadedEventStart at 0, so use L1.
  // See https://github.com/halalbooking/halalbooking/pull/31364
  const domContentLoadedFired = () =>
    document.readyState === "complete" ||
    (document.readyState === "interactive" &&
      performance.timing.domContentLoadedEventStart > 0)

  const onReady = (callback) => {
    // avoid paints out of flow
    const rAFcallback = () => requestAnimationFrame(callback)
    if (domContentLoadedFired()) {
      rAFcallback()
    } else {
      document.addEventListener("DOMContentLoaded", rAFcallback, false)
    }
  }

  window.HB = window.HB || {}
  window.HB.onReady = onReady
})()
